import { FieldSet, Form, Heading, Label, LabeledControl, Radio, Spacer } from '@zillow/constellation';
import { useMemo } from 'react';

type UpsellSurveyBodyProps = {
  onSurveyResponse: (surveyResponse: { declineReason: string; order: number }) => void;
};

const SURVEY_RESPONSES = [
  { declineReason: 'alreadyEnrolled', label: 'I already have renters insurance' },
  { declineReason: 'enrollLater', label: 'I plan to get it later' },
  { declineReason: 'wontEnrollZillow', label: "I don't want insurance through Zillow" },
  { declineReason: 'other', label: 'Other' },
];

const UpsellSurveyBody = ({ onSurveyResponse }: UpsellSurveyBodyProps) => {
  const shuffledSurveyResponses = useMemo(() => {
    const shuffledResponses = [...SURVEY_RESPONSES];

    for (let i = shuffledResponses.length - 2; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledResponses[i], shuffledResponses[j]] = [shuffledResponses[j], shuffledResponses[i]];
    }

    return shuffledResponses;
  }, []);

  return (
    <Spacer paddingX="sm" paddingY="md" data-testid="upsell-modal-upsell-survey">
      <Form onSubmit={(e: React.FormEvent) => e.preventDefault()}>
        <FieldSet
          legend={
            <Heading level="5" fontFamily="serif" marginBottom="sm">
              Let us know why you don&apos;t want renters insurance
            </Heading>
          }
        >
          {shuffledSurveyResponses.map((response, index) => (
            <LabeledControl
              key={response.declineReason}
              controlId={response.declineReason}
              label={<Label>{response.label}</Label>}
              control={<Radio name="decline-reason" />}
              onClick={() => onSurveyResponse({ declineReason: response.declineReason, order: index + 1 })}
            />
          ))}
        </FieldSet>
      </Form>
    </Spacer>
  );
};

export default UpsellSurveyBody;
